export const SORT_OPTIONS = [
  { value: 'default', labelKey: 'filters_sort_default' },
  { value: 'newest', labelKey: 'filters_sort_newest' },
  { value: 'cheapest', labelKey: 'filters_sort_cheapest' },
  { value: 'expensive', labelKey: 'filters_sort_expensive' },
  { value: 'gainer', labelKey: 'filters_sort_most_gainer' },
  { value: 'loser', labelKey: 'filters_sort_most_loser' },
]

export const STATE_OPTIONS = [
  { value: 'planning', labelKey: 'filters_state_planning' },
  { value: 'under_construction', labelKey: 'filters_state_under_construction' },
  { value: 'completed', labelKey: 'filters_state_completed' },
  { value: 'occupied', labelKey: 'filters_state_occupied' },
  { value: 'for_sale', labelKey: 'filters_state_for_sale' },
  { value: 'for_rent', labelKey: 'filters_state_for_rent' },
  { value: 'other', labelKey: 'filters_state_other' },
]

export const USAGE_OPTIONS = [
  { value: 'all', labelKey: 'filters_usage_all' },
  { value: 'residential', labelKey: 'filters_usage_residential' },
  { value: 'commercial', labelKey: 'filters_usage_commercial' },
  { value: 'industrial', labelKey: 'filters_usage_industrial' },
  { value: 'office', labelKey: 'filters_usage_office' },
  { value: 'agricultural', labelKey: 'filters_usage_agricultural' },
  { value: 'touristic', labelKey: 'filters_usage_touristic' },
  { value: 'mining', labelKey: 'filters_usage_mining' },
  { value: 'transportation', labelKey: 'filters_usage_transportation' },
  { value: 'land', labelKey: 'filters_usage_land' },
  { value: 'other', labelKey: 'filters_usage_other' },
]

export const CITY_DEFAULT = { value: 'all', labelKey: 'filters_city_all' }
export const NEIGHBORHOOD_DEFAULT = {
  value: 'all',
  labelKey: 'filters_neighborhood_all',
}
